module.exports = __webpack_public_path__ + "314c96f89fd0f4c63b0dce5ae2d83806.png";